export enum QueryResult {
  ok = 'ok',
  error = 'error',
}
